import { Button } from "antd";
import { FaArrowLeft, FaBackward, FaPhone } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { Link } from "react-router-dom";

const UserDetail = ({ responseData }) => {
  const type = localStorage.getItem("userType");
  const dateStr = responseData?.date_of_joining;
  const formattedDate = dateStr
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date(dateStr))
    : "";

  return (
    <>
      <div className="flex mb-3 mt-4 relative justify-end gap-2 ">
        {type !== "admin" && (
          <div className=" absolute left-0 ml-2 self-center">
            <Link to="/admin/employees-verification">
              <Button className="w-fit self-center px-3 py-2 rounded-md   flex items-center justify-center cursor-pointer">
                {/* <span className=""> Back</span> */}
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  class="mr-1 fs-5"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
                </svg>
              </Button>
            </Link>
          </div>
        )}
        <div className="w-fit self-center px-4 py-2 rounded-md text-white bg-[#009BDE] hover:bg-[#009BDE] shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer">
          <FaPhone size={16} className="text-lg font-bold mr-2" />

          <span className="font-semibold"> {responseData?.mobile}</span>
        </div>

        <div className="w-fit self-center px-4 py-2 rounded-md text-white bg-[#009BDE] hover:bg-[#009BDE] shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer">
          <HiOutlineMail size={18} className="text-lg font-bold mr-2" />

          <span className="font-semibold">Send Email to HR</span>
        </div>
      </div>
      <section className="bg-white p-6 shadow-sm border w-full rounded-lg">
        <div className=" justify-between items-center flex-wrap gap-4">
          {/* Left: User Info */}
          <div>
            <h2 className="text-xl mb-3 font-bold text-gray-800">
              {responseData?.name?.full_name}
            </h2>
            <div className="md:flex mt-2 gap-6 text-sm text-gray-600">
              <div className="flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Joining Date</p>
                <p className="font-bold">{formattedDate} </p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Designation</p>
                <p className="font-bold">{responseData?.designation}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Department</p>
                <p className="font-bold">{responseData?.function}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Location</p>
                <p className="font-bold">{responseData?.location?.corporate}</p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Employee Type</p>
                <p className="font-bold">
                  {responseData?.job_details?.employee_type}
                </p>
              </div>
              <div className="border-l pl-4 flex justify-between flex-col gap-1">
                <p className="text-gray-400 mb-0">Email</p>
                <p className="font-bold">{responseData?.email?.personal}</p>
              </div>
            </div>
          </div>

          {/* Right: Actions */}
        </div>
      </section>
    </>
  );
};

export default UserDetail;
